import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type WsapiImportDetailsFragment = { __typename?: 'WsapiImportStateData', wsapiImportId: string, integrationId: string, tenantId: string, enabled: boolean, runNow: boolean, scheduleDayOfWeek?: number | null, scheduleTimeOfDay?: string | null, created: Types.TDateISO, createdBy: string, updated: Types.TDateISO, updatedBy: string, entityMappings: Array<{ __typename?: 'EntityMappingData', entityMappingId: string, entityType: Types.WsapiImportEntityType, sourceTable: string, keySourceField: string, keyTargetField: string, enabled: boolean, fieldMappings: Array<{ __typename?: 'FieldMappingData', sourceField: string, targetField: string, sanitize: boolean, kind: Types.FieldMappingKind }> }> };

export type GetWsapiImportQueryVariables = Types.Exact<{
  wsapiImportId: Types.Scalars['String']['input'];
}>;


export type GetWsapiImportQuery = { __typename?: 'Query', wsapiImport?: { __typename?: 'WsapiImportStateData', wsapiImportId: string, integrationId: string, tenantId: string, enabled: boolean, runNow: boolean, scheduleDayOfWeek?: number | null, scheduleTimeOfDay?: string | null, created: Types.TDateISO, createdBy: string, updated: Types.TDateISO, updatedBy: string, entityMappings: Array<{ __typename?: 'EntityMappingData', entityMappingId: string, entityType: Types.WsapiImportEntityType, sourceTable: string, keySourceField: string, keyTargetField: string, enabled: boolean, fieldMappings: Array<{ __typename?: 'FieldMappingData', sourceField: string, targetField: string, sanitize: boolean, kind: Types.FieldMappingKind }> }> } | null };

export type GetWsapiImportsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.WsapiImportDocumentFilterInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  order?: Types.InputMaybe<Array<Types.WsapiImportDocumentSortInput> | Types.WsapiImportDocumentSortInput>;
}>;


export type GetWsapiImportsQuery = { __typename?: 'Query', wsapiImports?: { __typename?: 'WsapiImportsConnection', totalCount: number, nodes?: Array<{ __typename?: 'WsapiImportDocument', id: string, wsapiImportId: string, integrationId: string, tenantId: string, enabled: boolean, runNow: boolean, scheduleDayOfWeek?: number | null, scheduleTimeOfDay?: string | null, created: Types.TDateISO, createdBy: string, updated: Types.TDateISO, updatedBy: string, entityMappings: Array<{ __typename?: 'EntityMappingData', entityMappingId: string, entityType: Types.WsapiImportEntityType, sourceTable: string, keySourceField: string, keyTargetField: string, enabled: boolean, fieldMappings: Array<{ __typename?: 'FieldMappingData', sourceField: string, targetField: string, sanitize: boolean, kind: Types.FieldMappingKind }> }> }> | null } | null };

export const WsapiImportDetailsFragmentDoc = new TypedDocumentString(`
    fragment WsapiImportDetails on WsapiImportStateData {
  wsapiImportId
  integrationId
  tenantId
  enabled
  runNow
  scheduleDayOfWeek
  scheduleTimeOfDay
  created
  createdBy
  updated
  updatedBy
  entityMappings {
    entityMappingId
    entityType
    sourceTable
    keySourceField
    keyTargetField
    enabled
    fieldMappings {
      sourceField
      targetField
      sanitize
      kind
    }
  }
}
    `, {"fragmentName":"WsapiImportDetails"});
export const GetWsapiImportDocument = new TypedDocumentString(`
    query GetWsapiImport($wsapiImportId: String!) {
  wsapiImport(wsapiImportId: $wsapiImportId) {
    ...WsapiImportDetails
  }
}
    fragment WsapiImportDetails on WsapiImportStateData {
  wsapiImportId
  integrationId
  tenantId
  enabled
  runNow
  scheduleDayOfWeek
  scheduleTimeOfDay
  created
  createdBy
  updated
  updatedBy
  entityMappings {
    entityMappingId
    entityType
    sourceTable
    keySourceField
    keyTargetField
    enabled
    fieldMappings {
      sourceField
      targetField
      sanitize
      kind
    }
  }
}`);
export const GetWsapiImportsDocument = new TypedDocumentString(`
    query GetWsapiImports($where: WsapiImportDocumentFilterInput, $first: Int, $order: [WsapiImportDocumentSortInput!]) {
  wsapiImports(where: $where, first: $first, order: $order) {
    nodes {
      id
      wsapiImportId
      integrationId
      tenantId
      enabled
      runNow
      scheduleDayOfWeek
      scheduleTimeOfDay
      created
      createdBy
      updated
      updatedBy
      entityMappings {
        entityMappingId
        entityType
        sourceTable
        keySourceField
        keyTargetField
        enabled
        fieldMappings {
          sourceField
          targetField
          sanitize
          kind
        }
      }
    }
    totalCount
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetWsapiImport: build.query<GetWsapiImportQuery, GetWsapiImportQueryVariables>({
      query: (variables) => ({ document: GetWsapiImportDocument, variables })
    }),
    GetWsapiImports: build.query<GetWsapiImportsQuery, GetWsapiImportsQueryVariables | void>({
      query: (variables) => ({ document: GetWsapiImportsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetWsapiImportQuery, useLazyGetWsapiImportQuery, useGetWsapiImportsQuery, useLazyGetWsapiImportsQuery } = injectedRtkApi;
